import React from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  useActionData,
  useOutletContext,
  useRouteLoaderData,
} from 'react-router-dom';
import { SALES_TOGGLE } from '../../constants/toggleOptions';

import ReactTablev8 from '../../../UI/Table/ReactTablev8';
import ReportHeader from '../../ReportHeader';
import SalesReportPDF from './SalesReportPDF';
import formatCurrency from '../../../Dashboard/Widgets/utils/formatCurrency';
import ReportFooter from '../../ReportFooter';

function SalesReport() {
  const actionData = useActionData();
  const { dateTo, dateFrom } = useOutletContext();
  const rootLoader = useRouteLoaderData('root');
  if (actionData?.message !== 'success' || !actionData)
    return <p className="card p-4 mt-4 border-0">Error generating report</p>;

  const tableData = actionData?.data.map((item) => ({
    date: item.date,
    invoice_id: item.invoice_id,
    tax: item.tax,
    total: item.total,
    id: item.invoice_id,
  }));

  const tableSetup = [
    {
      header: 'Date',
      accessorKey: 'date',
      type: 'date',
      enableSorting: false,
      mobileLabel: true,
    },
    {
      header: 'Invoice',
      accessorKey: 'invoice_id',
      enableSorting: false,
    },
    {
      header: 'Tax',
      accessorKey: 'tax',
      type: 'money',
      enableSorting: false,
      mobileLabel: true,
    },
    {
      header: 'Amount',
      accessorKey: 'total',
      type: 'money',
      enableSorting: false,
      mobileLabel: true,
    },
  ];

  const totals = tableData.reduce(
    (acc, entry) => {
      return {
        subtotal: acc.subtotal + Number(entry.total),
        taxTotal: acc.taxTotal + Number(entry.tax),
        total: acc.total + Number(entry.total) + Number(entry.tax),
      };
    },
    {
      subtotal: 0,
      taxTotal: 0,
      total: 0,
    }
  );

  const tableOptions = {
    search: false,
    pagination: {
      show: false,
    },
    sorting: false,
  };

  return (
    <>
      <ReportHeader
        reportSection={SALES_TOGGLE}
        pdfDocument={
          <SalesReportPDF
            dateTo={dateTo}
            dateFrom={dateFrom}
            pdfData={{ tableData, tableSetup, totals }}
            userData={rootLoader}
          />
        }
      />
      <div className="container-fluid">
        {tableData.length === 0 ? (
          <Row>
            <Col className="alert alert-secondary" role="alert">
              No sales registered for this date range
            </Col>
          </Row>
        ) : (
          <div className="reports__display-react-table">
            <ReactTablev8
              dataTable={tableData}
              tableLayout={tableSetup}
              tableOptions={tableOptions}
              mobileClass="reports_sales_table"
            />
            <div className="reports__display-totals">
              <div>
                <h6>Totals</h6>
                <table>
                  <tbody>
                    <tr>
                      <td>Subtotal:</td>
                      <td style={{ paddingRight: 0 }}>$</td>
                      <td>{formatCurrency(totals.subtotal, 2, false)}</td>
                    </tr>
                    <tr>
                      <td>Total Tax:</td>
                      <td style={{ paddingRight: 0 }}>$</td>
                      <td>{formatCurrency(totals.taxTotal, 2, false)}</td>
                    </tr>
                    <tr>
                      <td>Total:</td>
                      <td style={{ paddingRight: 0 }}>$</td>
                      <td>
                        <strong>
                          {formatCurrency(totals.total, 2, false)}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <ReportFooter />
          </div>
        )}
      </div>
    </>
  );
}

export default SalesReport;
